const PREFIX = "moovs.paymentSetupAttempt:";
const MAX_AGE_MS = 30 * 60 * 1000;

export const createSetupKey = () =>
  Array.from(crypto.getRandomValues(new Uint8Array(16)), (byte) =>
    byte.toString(16).padStart(2, "0")
  ).join("");

export const retainSetupKey = (scope: string, key: string) => {
  try {
    sessionStorage.setItem(
      `${PREFIX}${scope}`,
      JSON.stringify({ key, expiresAt: Date.now() + MAX_AGE_MS })
    );
  } catch {
    // Checkout also works when browser storage is unavailable.
  }
};

export const readSetupKey = (scope: string): string | null => {
  try {
    const stored = JSON.parse(sessionStorage.getItem(`${PREFIX}${scope}`));
    if (
      /^[a-f0-9]{32}$/.test(stored?.key) &&
      stored.expiresAt > Date.now() &&
      stored.expiresAt <= Date.now() + MAX_AGE_MS
    )
      return stored.key;
  } catch {
    // An expired or invalid key starts a fresh attempt.
  }
  return null;
};

export const getSetupKey = (scope: string, restart = false) => {
  const stored = !restart && readSetupKey(scope);
  if (stored) return stored;
  const key = createSetupKey();
  retainSetupKey(scope, key);
  return key;
};

export const clearSetupKey = (scope: string) => {
  try {
    sessionStorage.removeItem(`${PREFIX}${scope}`);
  } catch {
    // Nothing is retained when browser storage is unavailable.
  }
};
